import { compose, withHandlers, withState } from 'recompose';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Layout from '../components/Layout';
import DatePicker from '../../../common/DatePickerV2';
import withReportsDateTime from '../hoc/withReportsDateTime';
import withNewDesignStyles from '../../../common/hoc/withNewDesignStyles';
import * as authSelectors from '../../../auth/selectors';
import Queue from '../../../queue/QueueContainer';

const CashRegisterHistory = ({ endingDateMax, startDate, endDate, onDateChange, showNowRecordsError, toDateFilter }) =>
  <Layout title="Cash Register History">
    <div className="c-report-filters u-mb">
      <div className="c-report-filters__item">
        <DatePicker
          end={endingDateMax}
          from={startDate}
          to={endDate}
          onChange={onDateChange}
          range
        />
      </div>
      <Queue
        name="reports"
        filters={toDateFilter()}
        dateFormat="YYYY/MM/DD"
        btnLabel="Export to CSV"
        jobName="cash-register-report"
        label="Cash register report"
        dateOnly
      />
    </div>
    <p display-if={showNowRecordsError}>
      There are no Cash Register records for the selected dates
    </p>
  </Layout>;

CashRegisterHistory.propTypes = {
  endingDateMax: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  showNowRecordsError: PropTypes.bool.isRequired,
  toDateFilter: PropTypes.func.isRequired,
};

export default compose(
    connect(state => ({
      brand: authSelectors.getActiveBrandId(state),
    })),
    withReportsDateTime,
    withState('showNowRecordsError', 'setShowNowRecordsError', false),
    withHandlers({
      toDateFilter: props => () => {
        return ({
          startDate: moment(props.startDate).format('YYYY/MM/DD'),
          endDate: moment(props.endDate).format('YYYY/MM/DD'),
        });
      },
    }),
    withNewDesignStyles,
)(CashRegisterHistory);
